let env = "https://cms-api.binawan.ac.id/api"

export default env;